import { Link } from 'react-router-dom';
import { useLocale, useTranslate } from '../../application/i18n/LocaleProvider';

/**
 * The way on from an answered round (SPEC-007 D-55, SPEC-008 PR-8.13).
 *
 * UNDER THE CLOCK rather than at the foot of the screen, and that is a CSS
 * `order` rather than a place in the document. The reader has just tapped a card
 * in the middle of the screen and the next thing they do is tap Next; a button
 * pinned to the bottom edge made every round a journey down the phone and back.
 * The DOM order stays what it reads as — what happened, then what is next — so a
 * screen reader is told the answer before it is offered the way on.
 *
 * A component of its own since the band gained a second control. It was four
 * lines of JSX in the screen's composition while it was one button; it is now a
 * band with a rule in it — which control belongs to which end of a round — and
 * the screen it came out of is a composition that has to stay readable as the
 * order the screen is in.
 *
 * THE SECOND CONTROL IS THE DUEL, and it is the second of the two doors the duel
 * got when the tab bar stopped carrying it. It hands over the pair the run ended
 * on, so a reader who has just been told they were wrong about which of two cars
 * is faster can go and see the two of them on every figure — the answer to
 * "why?", which is the one question a lost round leaves behind.
 *
 * ONLY ONCE THE RUN IS OVER. A link offered mid-round is the offer D-56 removed
 * from the reveal: it takes a reader off the screen they are playing on, and the
 * run they walk away from is gone. A run that has already ended has nothing left
 * to lose, which is what makes the same link a different offer here.
 *
 * And it lives in the FOOT rather than in the reveal above it, which is what
 * keeps D-55's split safe rather than a 1.3.2 violation: that argument rests on
 * the reveal holding no focusable element for the visual order to disagree with,
 * and a link added there would have taken it away.
 *
 * A THIRD CONTROL LIVED HERE FOR A REVISION and it was a car: a run whose score
 * had passed the next rung offered the legend on the reveal, and taking it was a
 * tap. SPEC-010 D-35 took the tap away — the ceremony opens itself now — and the
 * band is two controls again, which is the shape this file's whole argument is
 * about. It is recorded here rather than deleted silently because the placement
 * argument survived the control: anything that ever joins this band goes UNDER
 * the primary, or it collects something with the tap the reader meant for the
 * next question.
 */
export default function DuelFoot({ isOver, onAdvance, pair }) {
    const { localeCode } = useLocale();
    const t = useTranslate();

    return (
        <div className="duel__foot">
            <button type="button" className="button button--primary duel__advance" onClick={onAdvance}>
                {t(isOver ? 'duel.again' : 'duel.next')}
            </button>

            {isOver ? (
                <Link
                    className="button button--quiet duel__aside"
                    to={`/${localeCode}/compare?a=${pair[0].id}&b=${pair[1].id}`}
                >
                    {t('duel.over.compare')}
                </Link>
            ) : null}

        </div>
    );
}
